"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var requestStatus = function requestStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _RequestStatusTypes.default.UNINITIALIZED;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.PROVIDER_NAMES_REQUESTED:
      return _RequestStatusTypes.default.PENDING;

    case _ActionTypes.default.PROVIDER_NAMES_RECEIVED:
      return _RequestStatusTypes.default.SUCCEEDED;

    case _ActionTypes.default.PROVIDER_NAMES_FAILED:
      return _RequestStatusTypes.default.FAILED;

    default:
      return state;
  }
};

var names = function names() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.PROVIDER_NAMES_RECEIVED:
      return action.payload;

    default:
      return state;
  }
};

var _default = (0, _redux.combineReducers)({
  names: names,
  requestStatus: requestStatus
});

exports.default = _default;
module.exports = exports.default;